
<template>
  <div>
    <b-row>
      <b-col cols="12">
        

        <b-form @submit.prevent="filterDashboard(request)" class="">
          <b-row>

            <b-col sm="12" md="4" xl="3">
              <b-form-group :label="$t('Owners')" label-for="vi-devices-id">
                <v-select multiple :close-on-select="false" v-model="request.owners"
                  :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                  :options="[...owners]" :reduce="d => d.id" v-on:input="filterDataChanged" />
                <small v-if="errors && ('owners' in errors)" class="text-danger">
                  {{ $t(errors['owners'][0]) }}
                </small>
              </b-form-group>
            </b-col>


            <b-col sm="12" md="4" xl="3">
              <b-form-group :label="$t('contract')" label-for="vi-devices-id">
                <v-select multiple :close-on-select="false" v-model="request.contracts"
                  :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                  :options="[...contracts]" :reduce="d => d.id" v-on:input="filterDataChanged" />
                <small v-if="errors && ('contracts' in errors)" class="text-danger">
                  {{ $t(errors['contracts'][0]) }}
                </small>
              </b-form-group>
            </b-col>



            <b-col sm="12" md="4" xl="2">
              <b-form-group :label="$t('Groups')" label-for="vi-devices-id">
                <v-select multiple :close-on-select="false" v-model="request.groups"
                  :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                  :options="[...groups]" :reduce="d => d.id" v-on:input="filterDataChanged" />
                <small v-if="errors && ('groups' in errors)" class="text-danger">
                  {{ $t(errors['groups'][0]) }}
                </small>
              </b-form-group>
            </b-col>

            <b-col sm="12" md="4" xl="2">
              <b-form-group :label="$t('Device categories')" label-for="vi-devices-id">

                <v-select multiple :close-on-select="false" v-model="request.device_categories"
                  :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" label="name"
                  :options="device_categories.map((i) => ({ id: i, name: $t(i) }))"
                  :reduce="val => val.id" v-on:input="filterDataChanged" />
                <small v-if="errors && ('device_categories' in errors)" class="text-danger">
                  {{ $t(errors['device_categories'][0]) }}
                </small>
              </b-form-group>
            </b-col>



            <b-col sm="12" md="4" xl="1">

              <b-form-group :label="$t('types')" label-for="vi-devices-id">
                <v-select multiple :close-on-select="false" v-model="request.types"
                  :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                  :options="[...types]" :reduce="d => d.id" v-on:input="filterDataChanged" />
                <small v-if="errors && ('types' in errors)" class="text-danger">
                  {{ $t(errors['types'][0]) }}
                </small>
              </b-form-group>
            </b-col>

            <b-col sm="12" md="4" xl="1">
              <br />
              <b-button type="submit" variant="primary" class="mr-1">
                {{ $t('Filter') }}
              </b-button>
            </b-col>


          </b-row>
        </b-form>
      </b-col>
    </b-row>



<!--    <b-collapse id="collapse-1" class="mt-2 mb-1">-->
<!--    <b-row style="justify-content: center;">-->

<!--      <b-col cols="6"  md="6" sm="12">-->
<!--        <div >-->
<!--          <b-row>-->

<!--            <b-col cols="10">-->
<!--        <b-form-group :label="$t('Select Date')" label-for="report-date" :state="null" >-->
<!--        <flat-pickr   v-model="filterDate"  :state="null" class="form-control" :config="{ ...pickerOptions }"-->
<!--                placeholder="YYYY-MM-DD" />-->
<!--        </b-form-group>-->
<!--      </b-col>-->
<!--      <b-col cols="2">-->
<!--        <b-button  class="mt-2" variant="secondary left-radius"  @click="clearDate()">-->
<!--         {{ $t('clear') }}-->
<!--      </b-button>   -->
<!--    </b-col>-->
<!--    </b-row> -->
<!--    </div>-->
<!--      </b-col>-->
<!--      <b-col    cols="6" md="6" sm="12">-->
<!--        <div class="demo-inline-spacing mb-1">-->

<!--<div>-->

<!--  <b-card-text class="mb-0 mr-3">-->
<!--    {{ $t('Daily') }}-->
<!--  </b-card-text>-->
<!--  <b-form-checkbox v-model="checkedPeriod" :checked="checkedPeriod == 'daily' ? true : false" value="daily"-->
<!--    class="custom-control-primary" name="check-button" switch>-->
<!--    <span class="switch-icon-left">-->
<!--      <feather-icon icon="CheckIcon" />-->
<!--    </span>-->
<!--    <span class="switch-icon-right">-->
<!--      <feather-icon icon="XIcon" />-->
<!--    </span>-->
<!--  </b-form-checkbox>-->
<!--</div>-->

<!--&lt;!&ndash; primary &ndash;&gt;-->
<!--<div>-->

<!--  <b-card-text class="mb-0 mr-3">-->
<!--    {{ $t('Weekly') }}-->
<!--  </b-card-text>-->
<!--  <b-form-checkbox v-model="checkedPeriod" :checked="checkedPeriod == 'weekly' ? true : false" value="weekly"-->
<!--    class="custom-control-info" name="check-button" switch>-->
<!--    <span class="switch-icon-left">-->
<!--      <feather-icon icon="CheckIcon" />-->
<!--    </span>-->
<!--    <span class="switch-icon-right">-->
<!--      <feather-icon icon="XIcon" />-->
<!--    </span>-->
<!--  </b-form-checkbox>-->
<!--</div>-->

<!--&lt;!&ndash; secondary &ndash;&gt;-->
<!--<div>-->
<!--  <b-card-text class="mb-0 mr-3">-->
<!--    {{ $t('Monthly') }}-->
<!--  </b-card-text>-->
<!--  <b-form-checkbox v-model="checkedPeriod" :checked="checkedPeriod == 'monthly' ? true : false" value="monthly"-->
<!--    class="custom-control-warning" name="check-button" switch>-->
<!--    <span class="switch-icon-left">-->
<!--      <feather-icon icon="CheckIcon" />-->
<!--    </span>-->
<!--    <span class="switch-icon-right">-->
<!--      <feather-icon icon="XIcon" />-->
<!--    </span>-->
<!--  </b-form-checkbox>-->
<!--</div>-->

<!--&lt;!&ndash; success &ndash;&gt;-->
<!--<div>-->
<!--  <b-card-text class="mb-0 mr-3">-->
<!--    {{ $t('Quarterly') }}-->
<!--  </b-card-text>-->
<!--  <b-form-checkbox v-model="checkedPeriod" :checked="checkedPeriod == 'quarterly' ? true : false" value="quarterly"-->
<!--    class="custom-control-danger" name="check-button" switch>-->
<!--    <span class="switch-icon-left">-->
<!--      <feather-icon icon="CheckIcon" />-->
<!--    </span>-->
<!--    <span class="switch-icon-right">-->
<!--      <feather-icon icon="XIcon" />-->
<!--    </span>-->
<!--  </b-form-checkbox>-->
<!--</div>-->

<!--&lt;!&ndash; danger &ndash;&gt;-->
<!--<div>-->
<!--  <b-card-text class="mb-0 mr-3">-->
<!--    {{ $t('Yearly') }}-->
<!--  </b-card-text>-->
<!--  <b-form-checkbox v-model="checkedPeriod" :checked="checkedPeriod == 'yearly' ? true : false" value="yearly"-->
<!--    class="custom-control-dark" name="check-button" switch>-->
<!--    <span class="switch-icon-left">-->
<!--      <feather-icon icon="CheckIcon" />-->
<!--    </span>-->
<!--    <span class="switch-icon-right">-->
<!--      <feather-icon icon="XIcon" />-->
<!--    </span>-->
<!--  </b-form-checkbox>-->
<!--</div>-->

<!--</div>-->

<!--      </b-col>-->
<!--   -->
<!--    </b-row>-->
<!--    -->
<!--    </b-collapse>-->



<!--    <b-row id="period-filter-dev"  style="text-align:center;">-->
<!--      <b-button  id="period-btn"  v-b-toggle.collapse-1 variant="primary center">-->
<!--      <feather-icon icon="SettingsIcon" size="15" class="spinner" />-->
<!--      </b-button>     -->
<!--  </b-row>-->

  </div>
</template>

<script>

import ToggleCollapse from '@/views/ui/toggle-collapse/ToggleCollapse.vue'
import {
  BButton, BTable, BFormInvalidFeedback, BCard, BCol, BFormCheckboxGroup,
  BForm, BFormCheckbox, BFormRadioGroup, BFormGroup, BFormInput, BPagination,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText, BLink, BMedia,BCollapse,VBToggle
} from 'bootstrap-vue'


import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

import { ref, computed, watch, onUnmounted } from '@vue/composition-api'
import Cleave from 'vue-cleave-component'
import FilterForm from './form.js'
import Logic from './logic'
import store from '@/store'
import { FilterStore } from "@/views/dashboard/data/filter";
import DashBoardData from '@/views/dashboard/data/'
export default {
  props: {
    filterDashboard: { type: Function }
  },
  name: 'DashboardFilter',
  components: {
    BRow, BCard, BFormCheckboxGroup, BTable, BPagination,
    BCol, BFormRadioGroup, BFormInvalidFeedback,
    BAlert, BFormGroup, BFormInput, flatPickr,
    BFormCheckbox, BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner,

    BLink,
    BMedia,
    BCollapse,VBToggle

  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
  },

  setup(props,{root}) {
    const checkedPeriod = ref("daily")
    if (!store.hasModule('dashBoardFilter')) {
      store.registerModule('dashBoardFilter', FilterStore)
    }

    watch([checkedPeriod],()=>{
    
     
     store.dispatch('dashBoardFilter/setDashboardCurrentPeriod',checkedPeriod.value)
     props.filterDashboard(request.value)

    })




    const filterDataChanged = () => {

      // console.log('data changed in filter',request.value)

      let currentFilter = request.value;
     
      store.dispatch('dashBoardFilter/setDashBoardFilterData', currentFilter)

    }

    onUnmounted(() => {
      if (store.hasModule('dashBoardFilter'))

        store.unregisterModule('dashBoardFilter')
    })
    const { DevicesData, devices_data } = DashBoardData();



    const { owners, contracts, groups, device_categories, types } = FilterForm()
    const { request, errors, loading } = Logic()
    const filterDate=ref('')
    const  pickerOptions ={
        dateFormat: 'Y-m-d',
       
    
        enableTime: true,
        enableSeconds: true,
        defaultHour: 0,
        mode: 'single',
        time_24hr: true,
        altInput: true,
        onClose: function(selectedDates, dateStr, instance) {
        
        
        store.dispatch('dashBoardFilter/setDashBoardFilterDate', dateStr)
        let currentFilter = request.value;
     
      store.dispatch('dashBoardFilter/setDashBoardFilterData', Object.assign(currentFilter,{date:dateStr}))
       props.filterDashboard(request.value)
        },
        
        
      }

      const clearDate =()=>{
        let currentFilter = request.value;
        delete currentFilter.date
        store.dispatch('dashBoardFilter/setDashBoardFilterDate', '')
       
        props.filterDashboard(currentFilter) 
        store.dispatch('dashBoardFilter/setDashBoardFilterData', Object.assign(currentFilter,{date:''}))
        filterDate.value=null
      }
    return {
      filterDate,pickerOptions,
      devices_data,
      owners,
      contracts,
      device_categories,
      types,
      request,
      groups,
      errors,
      loading,
      filterDataChanged,
      /////////periods filters
      checkedPeriod,
      clearDate

    }
  }

}
</script>
<style scoped>

#period-btn{
 
  margin-left: auto;
  margin-right: auto;
  
  border-radius: 0 0 1rem 1rem;
}

element {
  text-align: center;
}
#period-filter-dev {
  
  margin-top: 10px;
  margin-bottom: -4.2rem;
}
.demo-inline-spacing.mb-1 {
  display: flex;
  align-items: initial;
  align-items: last baseline;
  justify-content: space-between;
}
html[dir="ltr"] .left-radius{
  margin-left:-3rem;border-radius: 0rem 2rem  2rem   0!important;
}
html[dir="rtl"] .left-radius{
  margin-right:-3rem;border-radius: 2rem 0rem 0 2rem !important;
}

</style>